export var getNumberErrorMessage = function (value, maxLength, type, isRequired) {
    if ((isRequired && !value) || (value && value.length < maxLength)) {
        return Promise.reject(new Error("Please enter a valid ".concat(maxLength, " digit ").concat(type, ".")));
    }
    return Promise.resolve();
};
export var getNumberRules = function (_a) {
    var maxLength = _a.maxLength, type = _a.type, _b = _a.isRequired, isRequired = _b === void 0 ? false : _b;
    return [
        {
            required: isRequired,
            validator: function (rule, _value) {
                return getNumberErrorMessage(_value, maxLength, type, isRequired);
            }
        }
    ];
};
